import { render, staticRenderFns } from "./Loads.vue?vue&type=template&id=2b3a1ee5&scoped=true"
import script from "./Loads.vue?vue&type=script&lang=js"
export * from "./Loads.vue?vue&type=script&lang=js"
import style0 from "./Loads.vue?vue&type=style&index=0&id=2b3a1ee5&prod&lang=scss"
import style1 from "./Loads.vue?vue&type=style&index=1&id=2b3a1ee5&prod&lang=scss&scoped=true"
import style2 from "./Loads.vue?vue&type=style&index=2&id=2b3a1ee5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3a1ee5",
  null
  
)

export default component.exports